"use strict";

var _types = require("./types");

var _types2 = _interopRequireDefault(_types);

var _WhetherEqual = require("./WhetherEqual");

var _WhetherEqual2 = _interopRequireDefault(_WhetherEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*
	intro : my function entry
	Author : chenchao
	Date : 2019-05-23
*/


module.exports = {
  Types: _types2.default,
  WhetherEqual: _WhetherEqual2.default
};